module.exports = __webpack_public_path__ + "media/application/images/process_steps/bookstack_03-9e3acb81cbd8f094e146fc88b295967e.png";